// Common Reusable Antd Form Data Validation Rules

import { type Rule } from 'antd/es/form';

export const requiredRule = (required: boolean, requiredMessage: string): Rule => ({
  required,
  message: requiredMessage,
});

export const emailRule = (isEmail: boolean, emailMessage: string): Rule => {
  if (!isEmail) return {};
  return {
    type: 'email',
    message: emailMessage,
  };
};

export const mobileNumberRule = (isNumber: boolean, numberMessage: string): Rule => {
  if (!isNumber) return {};
  return {
    min: 10,
    message: numberMessage,
  };
};
